import { render, staticRenderFns } from "./PartsMineNew.vue?vue&type=template&id=61caa4ea&"
import script from "./PartsMineNew.vue?vue&type=script&lang=ts&"
export * from "./PartsMineNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports